import type { Translations } from "../types";

const no: Translations = {
  "meta.title": "Klikk per land",
  "meta.description":
    "Interaktivt verdenskart: gratis klikk per land pluss betalt støtte via Stripe, PayPal og Buy Me a Coffee.",

  "app.title": "Klikk per land",

  "map.intro":
    "Klikk på et land på kartet for å gi det en gratis stemme, eller send økonomisk støtte - begge deler teller til den kombinerte rankingen nedenfor. Kartet gjenspeiler bare støtte innenfor denne appen, ikke faktisk nasjonal velstand eller BNP.",
  "map.verifying": "Verifiserer …",
  "map.confirmNotRobot": "Før du kan legge til gratis klikk, bekreft raskt at du ikke er en robot:",
  "map.tryAgain": "Prøv igjen",
  "map.registeringClick": "Registrerer klikk …",
  "map.selectedCountry": "Valgt land: {name}.",
  "map.selectFirstFeedback": "Land valgt. For å legge til et gratis klikk, bekreft først nedenfor at du ikke er en robot.",
  "map.verificationExpired": "Verifiseringen er utløpt - bekreft på nytt at du ikke er en robot.",
  "map.slowDown": "Litt saktere - vent et øyeblikk før neste klikk.",
  "map.clickFailed": "Kunne ikke registrere klikket. Prøv igjen.",
  "map.clickErrorGeneric": "Feil ved registrering av klikk.",
  "map.leaderboardHeading": "Landranking",
  "map.emptySelection": "Velg et land på kartet for å klikke på det eller støtte det.",
  "map.loadingData": "Laster inn data …",

  "worldmap.loadError": "Kunne ikke laste inn kartet.",
  "worldmap.resetZoom": "Tilbakestill zoom",
  "worldmap.resetButton": "⤾ Tilbakestill",
  "worldmap.loadingMap": "Laster inn kart …",
  "worldmap.unknownCountry": "Ukjent",
  "worldmap.ariaClicks": "{name}: {clicks} klikk",
  "worldmap.tooltipClicks": "{clicks} klikk",

  "legend.fewer": "Færre klikk",
  "legend.more": "Flere klikk",

  "list.empty": "Ingen klikk ennå. Bli den første!",
  "list.ariaLabel": "Landranking etter antall klikk",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY er ikke satt - se README for konfigurasjon.",
  "human.verificationFailedGeneric": "Verifiseringen mislyktes.",
  "human.networkError":
    "Fikk ikke kontakt med verifiseringen (nettverksfeil) - sjekk VITE_SUPABASE_URL, at verify-human er distribuert, og ALLOWED_ORIGIN; se README/NAVODILA.",
  "human.verificationFailedRetry": "Verifiseringen mislyktes, prøv igjen.",

  "provider.stripe": "💳 Kort (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Valgt land",
  "panel.currentlyRanked": "For øyeblikket rangert som #{rank}",
  "panel.shareCopied": "Kopiert ✓",
  "panel.shareShared": "Delt ✓",
  "panel.shareButton": "🔗 Del",

  "panel.tableClicks": "Klikk",
  "panel.tableFree": "Gratis",
  "panel.tablePaid": "Betalt",
  "panel.rowAllTime": "Totalt",
  "panel.rowThisYear": "I år",
  "panel.rowThisWeek": "Denne uken",
  "panel.rowToday": "I dag",

  "panel.totalCombined": "Totalt kombinert:",
  "panel.totalSupport": "Total støtte:",

  "panel.paymentMethod": "Betalingsmåte",
  "panel.noPaymentMethod": "Ingen betalingsmåte er tilgjengelig for øyeblikket.",
  "panel.supportAmount": "Støttebeløp (EUR)",
  "panel.amountRange": "Beløpet bør være mellom {min} og {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Estimerte betalte klikk:",
  "panel.ratioInfo":
    "Forhold: {a} = {b} klikk (f.eks. {c} = {d} klikk). Dette er bare et estimat før betaling - det endelige antallet klikk beregnes og bekreftes alltid av serveren basert på den faktisk bekreftede betalingen.",
  "panel.preparing": "Forbereder …",
  "panel.continueWith": "Fortsett med {provider}",
  "panel.choosePaymentMethod": "Velg en betalingsmåte",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME er ikke satt - se README for konfigurasjon.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID er ikke satt - se README for konfigurasjon.",

  "panel.paypalAmountInfo": "Beløp: {amount} (estimert {clicks} klikk). Fullfør betalingen med PayPal-knappen nedenfor.",
  "panel.back": "← Tilbake",

  "panel.bmcWarningTitle": "⚠️ Før du fortsetter til BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Lim inn koden nedenfor i melding-/notatfeltet ved kassen — det er den eneste måten vi vet hvilket land du støtter. Uten koden kan vi ikke koble betalingen til noe land.",
  "panel.copy": "Kopier",
  "panel.copied": "Kopiert ✓",
  "panel.suggestedAmount": "Foreslått beløp:",
  "panel.bmcAmountNote":
    "(estimert {clicks} klikk). BuyMeCoffee støtter dessverre ikke å overføre beløpet via lenken — angi/velg det selv på nettstedet deres. Det faktiske antallet klikk beregnes alltid ut fra beløpet du faktisk sender via BuyMeCoffee, ikke ut fra dette estimatet.",
  "panel.openBmc": "Åpne BuyMeCoffee og fortsett →",
  "panel.waitingProvider": "Venter på betalingsbekreftelse fra betalingsleverandøren …",
  "panel.waitingConfirmation": "Venter på betalingsbekreftelse …",
  "panel.timedOut":
    "Kontrollen tok for lang tid. Hvis du fullførte betalingen, oppdateres kartet så snart serveren mottar en bekreftelse - dette kan noen ganger ta litt lengre tid.",
  "panel.checkAgain": "Sjekk igjen",

  "panel.cancelled": "Betalingen ble avbrutt eller gikk ikke gjennom. Kartet er ikke endret.",
  "panel.tryAgain": "Prøv igjen",

  "panel.confirmed": "✅ Støtte bekreftet!",
  "panel.confirmedBody": "{country} mottok {clicks} betalte klikk for {amount}.",

  "panel.errorPreparingSupport": "Feil ved forberedelse av din støtte.",
  "panel.errorPreparingPayment": "Feil ved forberedelse av betaling.",
  "panel.errorConfirmingPayment": "Feil ved bekreftelse av betaling.",
  "panel.errorPayingPaypal": "Feil ved betaling med PayPal.",

  "share.unranked": "{flag}{country} trenger din støtte på verdenskartet!\nHjelp landet å klatre på rankingen 👇",
  "share.rank1": "{flag}{country} er for øyeblikket på #1!\nHjelp oss å holde toppen 👇",
  "share.rankN": "{flag}{country} er for øyeblikket på #{rank}!\nHjelp oss å nå #1 👇",

  "language.switcherLabel": "Språk",
};

export default no;
